import { Component, ErrorHandler, Inject, Input, DOCUMENT, ChangeDetectionStrategy } from '@angular/core'
import { Router } from '@angular/router'
import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { TunnistautuminenService } from 'app/_angular/service/tunnistautuminen.service'
import { LadataanService } from 'app/_jaettu-angular/service/ladataan.service'

import { TunnistautuminenNetsPankitComponent } from './pankit.component'

import { AloitaTunnistautuminenJaAnnaUrlResponse, InGroupeAuthMethod } from '@lemon/core-firebase/model/tunnistaminen'
import { TilintarkastajaAloitaTunnistautuminenRequest } from 'app/_jaettu-lemonator/model/tilintarkastaja'
import { environment } from 'environments/environment'

@Component({
  standalone: false,
  selector: '[tilintarkastaja-tunnistautuminen-pankit]',
  templateUrl: './pankit.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pankit.component.css'],
})
export class TilintarkastajaTunnistautuminenPankitComponent extends TunnistautuminenNetsPankitComponent {
  @Input() linkinAvain: string // Taikalinkin avain tilintarkastajan kutsulle

  constructor(
    @Inject(DOCUMENT) private __document: Document,
    private __ladataanService: LadataanService,
    private __errorHandler: ErrorHandler,
    private __tunnistautuminenService: TunnistautuminenService,
    private __router: Router,
    protected __firebaseLemonator: FirebaseLemonator,
  ) {
    super(__document, __ladataanService, __errorHandler, __tunnistautuminenService, __firebaseLemonator)
  }

  protected override _aloitaTunnistautuminenJaAnnaUrl(authMethod: InGroupeAuthMethod): Promise<AloitaTunnistautuminenJaAnnaUrlResponse> {
    const request: TilintarkastajaAloitaTunnistautuminenRequest = {
      action: 'continue-tilintarkastaja-tunnistautuminen',
      authMethod,
      kieli: this.kieli || 'fi',
      env: this._tunnistautuminenService.getNetsEnvironment(environment.environment),
      linkinAvain: this.linkinAvain,
    }
    return this._firebaseLemonator.functionsCall<TilintarkastajaAloitaTunnistautuminenRequest, AloitaTunnistautuminenJaAnnaUrlResponse>('tilintarkastajatAloitaTunnistautuminenJaAnnaUrl', request)
  }
}
